import { createAction, props } from '@ngrx/store';

export enum AppConfigActionTypes {
	ClearConfig = '[App config Effects] Clear',
}

/**
 * Clears all configs
 */
export const clearApplicationConfigAction = createAction('[App config Effects] Clear');

export const updateAccessoIdLoginConfig = createAction(
	'[App config Effects] Update AccessoId Login Config',
	props<{ show_legacy_sign_in: boolean }>()
);
